var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-cascader',{attrs:{"disabled":_vm.disableds,"options":_vm.options,"placeholder":_vm.placeholder},on:{"change":_vm.changeXzc},model:{value:(_vm.defaultValue),callback:function ($$v) {_vm.defaultValue=$$v},expression:"defaultValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }